enum CreatorHeaderActiveTabEnum{
    home = 1,
    manageCourse = 2,
    myKnowledge = 3,
    controlPanel = 4 
}

export default CreatorHeaderActiveTabEnum;